'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import { FC, useRef } from 'react';
import { CasesScrollItemDto } from '@/components/Partnership/CasesSliderScroll/types';
import VimeoPlayer from '@/components/shared/VimeoPlayer';
import { useVimeoViewportPlayback } from '@/hooks/useVimeoViewportPlayback';
import css from './style.module.scss';
const MobileCaseMediaLink: FC<{
  slide: CasesScrollItemDto;
}> = t0 => {
  const $ = _c(9);
  const {
    slide
  } = t0;
  const linkRef = useRef(null);
  const playing = useVimeoViewportPlayback(linkRef);
  if (!slide.cta?.url) {
    return null;
  }
  let t1;
  if ($[0] !== playing || $[1] !== slide.image || $[2] !== slide.slideTitle || $[3] !== slide.videoThumbnailUrl || $[4] !== slide.videoUrl) {
    t1 = slide.videoUrl ? <VimeoPlayer fitCover={true} playing={playing} url={slide.videoUrl} thumbnailUrl={slide.videoThumbnailUrl || undefined} className={css.video} /> : slide.image?.url ? <Image className={css.image} width={1200} height={800} src={slide.image.url} alt={slide.slideTitle || ""} /> : null;
    $[0] = playing;
    $[1] = slide.image;
    $[2] = slide.slideTitle;
    $[3] = slide.videoThumbnailUrl;
    $[4] = slide.videoUrl;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== slide.cta.url || $[7] !== t1) {
    t2 = <Link ref={linkRef} type="link" href={slide.cta.url} className={css.mobileMedia}>{t1}</Link>;
    $[6] = slide.cta.url;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default MobileCaseMediaLink;